module.exports = __webpack_public_path__ + "img/摄影图-医疗健康-DSC_6587.92578ca7.jpg";